module.exports = __webpack_public_path__ + "static/media/einvoice-pending.0e9f5767.svg";